import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import OCRModal from './OCRModal';
import { LanguageSwitcher, useLanguage } from '../i18n/LanguageContext';
import './Header.css';

// REVAMP: public, login-free header with branding, OCR helper and language switch.
const Header: React.FC = () => {
  const [showOCRModal, setShowOCRModal] = useState(false);
  const { t } = useLanguage();

  return (
    <>
      <header className="header">
        <div className="header-content">
          <Link to="/app" className="logo">
            <span className="logo-icon">🧠</span>
            <span className="logo-text">StudyMind</span>
          </Link>

          <div className="header-right" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <button
              type="button"
              className="header-tool-button ocr-header-button"
              onClick={() => setShowOCRModal(true)}
              title="Extract text from a PDF/image"
            >
              {t('common.ocr')}
            </button>
            <Link to="/blog" className="header-tool-button blog-header-button" title="Study tips & guides">
              {t('common.blog')}
            </Link>
            <LanguageSwitcher style={{ color: 'inherit' }} />
          </div>
        </div>
      </header>

      <OCRModal
        isOpen={showOCRModal}
        onClose={() => setShowOCRModal(false)}
        onTextExtracted={(text: string) =>
          console.log('Text extracted from OCR:', text.length, 'characters')
        }
      />
    </>
  );
};

export default Header;
